import { RouteObject } from "react-router-dom";
import { MESSAGE, MESSAGE_ROOM } from "constants/urls";

export default [
  {
    index: true,
    path: MESSAGE,
    lazy: () => import("modules/message/pages/MessageInbox"),
  },
  {
    path: MESSAGE_ROOM,
    lazy: () => import("modules/message/pages/MessageInbox"),
  },
] as RouteObject[];
